import { SettingsToggleCard } from '@/components/molecules'
import { useTranslation } from 'react-i18next'

type WeatherSettingProps = {
    value: boolean
    onChange: (value: boolean) => void
}

export const WeatherSetting: React.FC<WeatherSettingProps> = (props) => {
    const { value, onChange } = props
    const { t } = useTranslation('translations')

    return (
        <SettingsToggleCard
            checked={value}
            onChange={onChange}
            title={t('analytics.benchmarking.normalization.weather.title')}
            description={t(
                'analytics.benchmarking.normalization.weather.description'
            )}
        />
    )
}
